import { APP_SETTINGS_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";
import { settingsClient } from "@core/clients";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

type AppSettingsQueryData = Awaited<ReturnType<typeof settingsClient.getSettings>>;

const useGetSettingsQuery = (options: UseQueryOptions<AppSettingsQueryData> = {}) => {
  const settingsQuery = useQuery<AppSettingsQueryData, any>(
    ["app-settings"],
    async () => {
      return await settingsClient.getSettings();
    },
    {
      cacheTime: APP_SETTINGS_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: APP_SETTINGS_QUERY_CACHE_EXPIRE_TIME_MS,
      ...options,
    }
  );

  return settingsQuery;
};

export default useGetSettingsQuery;
